/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable max-len */
import { useRef, forwardRef, useImperativeHandle, useState, useEffect, useMemo } from 'react';

import useStyles from './style';
import { Button, Grid, Typography } from '@material-ui/core';
import {
  dataHarmony,
  dataPreference,
  getFromLS,
  publicImgMajorTest,
  publicSvgPath,
  resultatWithColor,
} from '@orientaction/utils';
import dateFormat from 'dateformat';
import { getUserById } from '../../../../services/user.service';
import { appLanguage } from '@orientaction/reducers';
import { useSelector } from 'react-redux';
import { concat, take } from 'lodash';
import { UserResultRadarGraph } from '@orientaction/components';

export interface ResultatPDFHandle {
  handleDownload: () => Promise<void>;
}

const ResultatPDF = forwardRef<ResultatPDFHandle, { myResult: any; idResult: number }>(
  ({ myResult, idResult }, ref) => {
    const classes = useStyles({});
    const headerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const chartContainerRef = useRef<HTMLDivElement>(null);
    const { users_permissions_user, resultat, listHistory } = myResult;
    const token = getFromLS('userToken') || '';
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [date, setDate] = useState<string>('');
    const [chartImage, setChartImage] = useState<string | null>(null);
    const lang: string = useSelector(appLanguage);
    const userInfo = JSON.parse(getFromLS('userInfos') || '{}');
    const titlesParagraphs = [
      'Commencez par adopter les bons réflexes',
      'Développez votre capacité à raisonner de façon logique',
      'Jouez et jouez encore pour développer votre créativité',
    ];

    useEffect(() => {
      const getUser = () => {
        setLoading(true);
        if (token && userInfo?.id) {
          getUserById({ token, userId: userInfo?.id })
            .then((res: any) => {
              setUser(res?.data ?? {});
              return 'ok';
            })
            .then(() => {
              setLoading(false);
            });
        }
      };
      getUser();
    }, [userInfo?.id, token]);

    // Convertir le canvas Chart.js en image
    useEffect(() => {
      if (!myResult || loading) return;

      const convertChartToImage = () => {
        // Attendre que le canvas soit rendu
        const checkCanvas = setInterval(() => {
          const canvas = document.querySelector('canvas#canvas-data-bar') as HTMLCanvasElement;
          if (canvas && canvas.width > 0 && canvas.height > 0) {
            clearInterval(checkCanvas);
            try {
              // Convertir le canvas en image base64 avec haute qualité
              const imageData = canvas.toDataURL('image/png', 1.0);
              setChartImage(imageData);
            } catch (error) {
              // En cas d'erreur, on continue sans l'image
              // eslint-disable-next-line no-console
              console.error('Erreur lors de la conversion du canvas en image:', error);
            }
          }
        }, 200);

        // Timeout après 5 secondes pour éviter une boucle infinie
        setTimeout(() => {
          clearInterval(checkCanvas);
        }, 5000);
      };

      // Attendre que le graphique soit complètement rendu
      const timer = setTimeout(() => {
        convertChartToImage();
      }, 1500);

      return () => {
        clearTimeout(timer);
      };
    }, [myResult, loading]);

    const handleDownload = async () => {
      if (!headerRef.current || !contentRef.current) {
        return;
      }

      // S'assurer que l'image du graphique est générée avant l'export
      if (!chartImage) {
        const canvas = document.querySelector('canvas#canvas-data-bar') as HTMLCanvasElement;
        if (canvas && canvas.width > 0 && canvas.height > 0) {
          try {
            const imageData = canvas.toDataURL('image/png', 1.0);
            setChartImage(imageData);
            // Attendre un peu pour que l'image soit mise à jour dans le DOM
            await new Promise(resolve => setTimeout(resolve, 300));
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Erreur lors de la conversion du canvas en image:', error);
          }
        } else {
          // Attendre que le canvas soit rendu
          await new Promise(resolve => setTimeout(resolve, 1000));
          const canvasRetry = document.querySelector('canvas#canvas-data-bar') as HTMLCanvasElement;
          if (canvasRetry && canvasRetry.width > 0 && canvasRetry.height > 0) {
            try {
              const imageData = canvasRetry.toDataURL('image/png', 1.0);
              setChartImage(imageData);
              await new Promise(resolve => setTimeout(resolve, 300));
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error('Erreur lors de la conversion du canvas en image:', error);
            }
          }
        }
      }

      const { default: html2pdf } = await import('html2pdf.js');

      // Options pour le premier PDF (header sans margin)
      const headerOptions = {
        margin: [0, 0, 0, 0], // Pas de margin pour le header
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          letterRendering: true,
          backgroundColor: '#FFF',
          removeContainer: true,
          allowTaint: true,
        },
        jsPDF: {
          unit: 'px',
          // Format A4 en pixels à ~150 DPI : 1240px × 1754px (210mm × 297mm)
          format: [1240, 1754],
          orientation: 'portrait',
          compress: true,
        },
        pagebreak: {
          mode: ['css', 'legacy'],
          after: '.page-break-after',
        },
      } as any;

      // Options pour le second PDF (contenu avec margin)
      const contentOptions = {
        margin: [80, 0, 80, 0], // Margin global pour le contenu
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          letterRendering: true,
          backgroundColor: '#F7F7FB',
          removeContainer: true,
          allowTaint: true,
          // Callback simple pour forcer les styles de page-break sur les paragraphes
          // onclone: (clonedDoc: Document) => {
          //   // Appliquer pageBreakInside: avoid sur tous les paragraphes
          //   const paragraphs = clonedDoc.querySelectorAll('p');
          //   paragraphs.forEach((p: Element) => {
          //     const element = p as HTMLElement;
          //     element.style.pageBreakInside = 'avoid';
          //     element.style.breakInside = 'avoid';
          //     element.style.orphans = '3';
          //     element.style.widows = '3';
          //   });
          // },
        },
        jsPDF: {
          unit: 'px',
          // Même format que le header pour garder un rendu homogène
          format: [1240, 1754],
          orientation: 'portrait',
          compress: true,
        },
        pagebreak: {
          mode: ['css', 'legacy'],
          before: '.page-break-before',
          after: '.page-break-after',
        },
      } as any;

      try {
        // Générer le premier PDF (header) en mémoire
        const headerPdfBlob = await html2pdf()
          .set(headerOptions)
          .from(headerRef.current)
          .output('blob');

        // Générer le second PDF (contenu) en mémoire
        const contentPdfBlob = await html2pdf()
          .set(contentOptions)
          .from(contentRef.current)
          .output('blob');

        // Convertir les blobs en ArrayBuffers
        const headerArrayBuffer = await headerPdfBlob.arrayBuffer();
        const contentArrayBuffer = await contentPdfBlob.arrayBuffer();

        // Utiliser pdf-lib pour fusionner les PDFs
        const { PDFDocument } = await import('pdf-lib');

        // Créer un nouveau document PDF
        const mergedPdf = await PDFDocument.create();

        // Charger les deux PDFs
        const headerPdfDoc = await PDFDocument.load(headerArrayBuffer);
        const contentPdfDoc = await PDFDocument.load(contentArrayBuffer);

        // Copier toutes les pages du header PDF
        const headerPages = await mergedPdf.copyPages(headerPdfDoc, headerPdfDoc.getPageIndices());
        headerPages.forEach((page: any) => mergedPdf.addPage(page));

        // Copier toutes les pages du content PDF
        const contentPages = await mergedPdf.copyPages(
          contentPdfDoc,
          contentPdfDoc.getPageIndices()
        );
        contentPages.forEach((page: any) => mergedPdf.addPage(page));

        // Sauvegarder le PDF fusionné
        const mergedPdfBytes = await mergedPdf.save();
        const uint8Array = new Uint8Array(mergedPdfBytes);
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Résultat Harmony® test des 16 soft skills - ${user?.firstname || ''} ${
          user?.lastname || ''
        }.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Erreur lors de la génération du PDF:', error);
      }
    };

    useImperativeHandle(ref, () => ({
      handleDownload,
    }));

    const harmonyData: any = useMemo(() => {
      return dataHarmony(myResult);
    }, [myResult]);

    // Fonction helper pour générer une section de soft skill
    const renderSoftSkillSection = (index: number) => {
      const item = harmonyData[index];
      if (!item) return null;

      return (
        <div className={`${classes.section} page-break-before`} style={{ paddingTop: 0 }}>
          <div className={classes.score}>
            {item?.key}
            <span>{item?.value}</span>
            <span>/100</span>
          </div>
          <h2 className={`${classes.heading} ${classes.h2}`} style={{ marginTop: 60 }}>
            Définition de la soft skill
          </h2>
          <p
            className={classes.paragraph}
            style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
            dangerouslySetInnerHTML={{
              __html: item?.text1,
            }}
          />
          <div
            className={`${classes.imgWhiteBanner}`}
            style={item?.key === 'Créativité' ? { width: '75%' } : {}}>
            <img src={`${publicSvgPath}/${item?.img}`} alt="img" />
          </div>
          <h2 className={`${classes.heading} ${classes.h6}`} style={{ marginTop: 40 }}>
            Fonctions et/ou métiers dans lesquels elle est déterminante
          </h2>
          <ul className={classes.listUl}>
            {item?.listEmploi1?.map((emploi: any) => {
              const cleanedEmploi = emploi?.replace(/<br\s*\/?>/gi, '') || emploi;
              return (
                <li className={classes.listLi} key={emploi}>
                  {cleanedEmploi}
                </li>
              );
            })}
          </ul>

          <p
            className={`${classes.paragraph} page-break-before`}
            style={{ textAlign: 'center', marginBottom: 80 }}
            dangerouslySetInnerHTML={{
              __html: item?.citation,
            }}
          />
          <h2 className={`${classes.heading} ${classes.h3}`}>{item?.title}</h2>
          {item?.key === "Esprit d'entreprendre" && Array.isArray(item?.text2) ? (
            <>
              {item.text2
                .flatMap((textPart: string) => 
                  String(textPart || "").split(/<br\s*\/?><br\s*\/?>/i)
                )
                .filter((line: string) => line.trim() !== '')
                .map((line: string, idx: number) => (
                  <p
                    className={classes.paragraph}
                    key={`${idx}-${line}`}
                    dangerouslySetInnerHTML={{ __html: line }}
                  />
                ))}
            </>
          ) : (
            <p
              className={classes.paragraph}
              style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4, marginBottom: 60 }}
              dangerouslySetInnerHTML={{
                __html: item?.text2,
              }}
            />
          )}

          {item?.listeAccordeon?.map((accordeonItem: any) => (
            <div key={accordeonItem.title} style={{ marginBottom: '60px' }}>
              <h2 className={`${classes.heading} ${classes.h6}`}>{accordeonItem.title}</h2>
              {accordeonItem?.description?.map((descriptionItem: any, descIndex: number) => {
                const lines = descriptionItem
                  .split(/<br\s*\/?>/i)
                  .filter((line: string) => line.trim() !== '');
                return lines.map((line: string, lineIndex: number) => {
                  const lineKey = `${accordeonItem.title}-${descIndex}-${line.substring(
                    0,
                    20
                  )}-${lineIndex}`;
                  return (
                    <p
                      key={lineKey}
                      className={classes.paragraph}
                      dangerouslySetInnerHTML={{ __html: line.trim() }}
                    />
                  );
                });
              })}
              {item?.descriptionAd && titlesParagraphs.includes(accordeonItem.title) && (
                <p className={classes.paragraph} style={{ marginTop: 20 }}>
                  <b>{item.titleAd}</b> →{' '}
                  <span
                    className={classes.paragraph}
                    dangerouslySetInnerHTML={{ __html: item.descriptionAd }}
                  />
                </p>
              )}
              {item?.descriptionAd && accordeonItem.title === 'Allez chercher l’échec' && (
                <p className={classes.paragraph} style={{ marginTop: 20 }}>
                  <b>{item.titleAd}</b> →{' '}
                  {item.descriptionAd
                    .split(/<br\s*\/?><br\s*\/?>/i)
                    .filter((line: string) => line.trim() !== '')
                    .map((line: string) => (
                      <p
                        className={classes.paragraph}
                        key={line}
                        dangerouslySetInnerHTML={{ __html: line }}
                      />
                    ))}
                </p>
              )}
            </div>
          ))}
        </div>
      );
    };

    return (
      <>
        {!loading && myResult && (
          <div className={classes.wrapper}>
            {/* Premier export PDF - Header sans margin */}
            <div ref={headerRef} className={classes.page}>
              <div id="ma-banniere-pdf" className={`${classes.header}`}>
                <Typography variant="h2" className={classes.titleHeader} style={{ margin: 0 }}>
                  Harmony®, <br />
                  test des 16 soft skills
                </Typography>
              </div>
              <div className="page-break-after" style={{ padding: '80px 80px 0px 80px' }}>
                <div className={classes.imgBanner}>
                  <img src={`${publicImgMajorTest}/banniere_harmony.png`} alt="couverture intro" />
                </div>
                <div className={classes.info}>
                  <div className={classes.infoContent}>
                    Nom du test : <span>Harmony®, test des 16 soft skills</span>
                  </div>
                  <div className={classes.infoContent}>
                    Bénéficiaire :{' '}
                    <span>
                      {user?.firstname} {user?.lastname}
                    </span>
                  </div>
                  <div className={classes.infoContent}>
                    Date de passation :{' '}
                    <span>
                      {myResult?.realization_date &&
                        dateFormat(new Date(myResult?.realization_date), 'dd/mm/yyyy')}
                    </span>
                  </div>
                  <div className={classes.infoContent}>
                    Consultant :{' '}
                    <span>
                      {user?.upper_hierarchy?.firstname} {user?.upper_hierarchy?.lastname}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Second export PDF - Contenu avec margin */}
            <div ref={contentRef} className={classes.page}>
              <div style={{ padding: '0px 80px 0px 80px' }}>
                <div className={`${classes.section}`}>
                  <h2 className={`${classes.heading} ${classes.h1}`} style={{ marginTop: 0 }}>
                    Synthèse de vos résultats
                  </h2>
                  <div className={classes.sliderScore}>
                    <div className={classes.podium} ref={chartContainerRef}>
                      {chartImage ? (
                        <img
                          src={chartImage}
                          alt="Graphique des résultats"
                          style={{
                            width: '100%',
                            height: 'auto',
                            maxWidth: '100%',
                            display: 'block',
                          }}
                        />
                      ) : (
                        <div style={{ position: 'relative' }}>
                          {myResult && (
                            <UserResultRadarGraph resultToShow={myResult} useForPFD={true} />
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <h2 className={`${classes.heading} ${classes.h4}`} style={{ marginTop: 30 }}>
                    Découvrez vos 16 soft skills
                  </h2>
                  <p className={classes.paragraph}>
                    Les soft skills ou compétences douces sont des compétences que l’on acquiert par
                    l’expérience, par opposition aux hard skills qui s’acquièrent dans le cadre
                    d’une formation ou de ses études. <br /> <br />
                    Les soft skills sont aujourd’hui la clef de la réussite professionnelle. Les
                    développer vous aidera à devenir un(e) collaborateur (trice) reconnu(e) et
                    apprécié(e) dans son organisation. Dans votre sphère de vie personnelle, cela
                    fera de vous une personne accomplie et respectée pour ses qualités humaines. Le
                    fait de les tester est une première étape avant de progresser. À vous de jouer !
                  </p>

                  <h2 className={`${classes.heading} ${classes.h6}`} style={{ marginTop: 80 }}>
                    Vos 3 soft skills les + développés
                  </h2>
                  <div
                    style={{ paddingLeft: 10, paddingRight: 10, marginTop: 10, marginBottom: 10 }}>
                    <Grid container={true} spacing={2} alignItems="center" justifyContent="center">
                      {take(harmonyData, 3)?.map((elem: any) => (
                        <Grid item={true} xs={4} key={elem.category}>
                          <Button
                            variant="contained"
                            style={{
                              background: elem.color,
                              width: '100%',
                              color: 'white',
                              height: 70,
                              fontSize: 20,
                              borderRadius: 15,
                            }}
                            color="primary"
                            disableElevation={true}>
                            {elem.key}
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                </div>

                {renderSoftSkillSection(0)}
                {renderSoftSkillSection(1)}
                {renderSoftSkillSection(2)}
                {/* {renderSoftSkillSection(3)}
                {renderSoftSkillSection(4)}
                {renderSoftSkillSection(5)}
                {renderSoftSkillSection(6)}
                {renderSoftSkillSection(7)}
                {renderSoftSkillSection(8)}
                {renderSoftSkillSection(9)}
                {renderSoftSkillSection(10)}
                {renderSoftSkillSection(11)}
                {renderSoftSkillSection(12)}
                {renderSoftSkillSection(13)}
                {renderSoftSkillSection(14)}
                {renderSoftSkillSection(15)} */}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
);

ResultatPDF.displayName = 'ResultatPDF';

export default ResultatPDF;
